import { Api, Auth } from '~/services'

export function getNotifications( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_NOTIFICATIONS'
				})

				Api.get( '/wp/notifications', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_NOTIFICATIONS',
						notifications: data
					})
				})
			}
		)
	}
}

export function getNewNotifications( highestId ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;
		if( !highestId ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_NOTIFICATIONS'
				})

				Api.get( '/wp/notifications/after/' + highestId, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {

					if( !data || !data.length || !!error ) return;

					dispatch({
						type: 'RECEIVE_NEW_NOTIFICATIONS',
						notifications: data
					})

					let notification = {
						text: 'You have ' + data.length + ' new notification' + (data.length > 1 ? 's' : ''),
						type: 'info',
						ID: Math.random() * (11000 - 10000) + 10000
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: notification
					})

				})
			}
		)
	}
}

export function seenNotification( notification_id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !notification_id ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_NOTIFICATION'
				})

				Api.put( '/wp/notification/' + notification_id + '/seen', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_NOTIFICATION',
						notification: data
					})
				})
			}
		)
	}
}





// WEBPACK FOOTER //
// ./src/js/actions/notifications.js